import UserApi from "@/scripts/api/user.api";
import Global from "@/scripts/Global";
import VueSignals from "@/scripts/VueSignals";

export default {
    name: 'ConfirmPassword',
    data() {
        return {
            user: {
                email: '',
                password: '',
            },
            contact_name: "",
            error_message: "",
            loading: false,
            session_id: '',
            hasEmail: true,
        }
    },
    mounted() {
        Global.removeAllCookiesExcept(['login_token', 'login_email', 'rememberPW'], true)
        if (typeof this.$route.query.u != 'undefined') {
            this.contact_name = this.$route.query.u
            this.isInvitationUserLink = true
        }
        if (typeof this.$route.query.c != 'undefined') {
            this.contact_name = this.$route.query.c
            this.isInvitationChannelLink = true
        }
        if (typeof this.$route.query.e != 'undefined') {
            this.user.email = this.$route.query.e
            this.hasEmail = false
        }
    },
    methods: {
        ConfirmLogin() {
            UserApi.login(this.user.email, this.user.password).then(res => {
                if (res.data.result) {
                    this.session_id = res.data.session_id
                } else {
                    this.error_message = "Password is worng"
                }
            }).then(res => {
                if (this.isInvitationUserLink) {
                    this.publicUserContact()
                } else if (this.isInvitationChannelLink) {
                    this.publicChannelContact()
                }
            })
        },
        publicUserContact() {
            UserApi.RegisterByPublicContact(this.contact_name, this.session_id).then(res => {
                if (res.data.result) {
                    Global.setSessionID(this.session_id)
                    Global.globalValue(VueSignals.AUTHENTICATED, true)
                    Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
                    Global.globalValue(VueSignals.SESSION_ID, this.session_id)
                    Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel.channel_id)
                } else {
                    if (res.data.reason == "user_not_found") {
                        this.error_message = "User is not exist"
                    }

                    if (res.data.reason == "user_not_public") {
                        this.error_message = "The mentioned user is blocking the public chat"
                    }

                    if (res.data.reason == "channel_already_exists") {
                        Global.setSessionID(this.session_id)
                        Global.globalValue(VueSignals.AUTHENTICATED, true)
                        Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
                        Global.globalValue(VueSignals.SESSION_ID, this.session_id)
                        Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel_id)
                    }
                }
            })
        },
        publicChannelContact() {
            ChannelApi.RegisterByPublicContact(this.channel_id, this.session_id).then(res => {
                if (res.data.result) {
                    Global.setSessionID(this.session_id)
                    Global.globalValue(VueSignals.AUTHENTICATED, true)
                    Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
                    Global.globalValue(VueSignals.SESSION_ID, this.session_id)
                    Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel.channel_id)
                } else {
                    if (res.data.reason == "channel_not_found") {
                        this.error_message = "Channel is not exist"
                    }

                    if (res.data.reason == "channel_not_public") {
                        this.error_message = "The mentioned channel is blocking the public join"
                    }

                    if (res.data.reason == "channel_already_exists") {
                        Global.setSessionID(this.session_id)
                        Global.globalValue(VueSignals.AUTHENTICATED, true)
                        Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
                        Global.globalValue(VueSignals.SESSION_ID, this.session_id)
                        Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel_id)
                    }
                }
            })
        }
    }
}
